import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	openApproverIcon: {
		id: 'software-releases-approvers.task-approver.open-approver-icon',
		defaultMessage: 'click to open approver',
		description: 'A aria label to open approver details',
	},
});
